import React from 'react';

export const CartIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg viewBox="0 0 73 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <line
      y1="-2"
      x2="38.7401"
      y2="-2"
      transform="matrix(0.708927 0.705282 -0.710742 0.703453 0.702774 20.6772)"
      stroke="#8092A0"
      strokeWidth="4"
    />
    <line
      y1="-2"
      x2="63.3124"
      y2="-2"
      transform="matrix(0.703434 -0.710761 0.716177 0.697919 28.1667 48)"
      stroke="#8092A0"
      strokeWidth="4"
    />
  </svg>
);
